import { getData as apiGetData } from 'api/Api'
import {
  setLoadStatus,
  addArray as addBlockersToBoard
} from '../redux/blockers'
import {
  addArray as addBlockerArray,
} from 'store/redux/blockers'
import blockerType from 'const/blockerType'

type Payload = {
  boardId: number
}

const fetchBlockers = (payload: Payload) => async dispatch => {
  const { boardId } = payload

  dispatch(setLoadStatus({
    boardId,
    isLoading: true,
    isLoaded: false
  }))

  try {
    const { Blockers } = await apiGetData('BoardBlockers', {
      boardId
    })

    const boardBlockerIds: number[] = []
    const blockers: any[] = []

    Blockers.forEach(Blocker => {
      if (Blocker.Type !== blockerType.GLOBAL) {
        boardBlockerIds.push(Blocker.Id)
      }
      
      blockers.push({
        id: Blocker.Id,
        type: Blocker.Type,
        name: Blocker.Name,
        description: Blocker.Description && JSON.parse(Blocker.Description),
        position: Blocker.Position,
      })
    })

    dispatch([
      addBlockerArray(blockers),
      addBlockersToBoard({
        boardId,
        array: boardBlockerIds
      }),
      setLoadStatus({
        boardId,
        isLoading: false,
        isLoaded: true
      })
    ])
  } catch (error) {
    dispatch(setLoadStatus({
      boardId,
      isLoading: false,
      isLoaded: false
    }))
  }
}

export default fetchBlockers
